import React from 'react';
import {
    IBasicProfile,
    FallbackProfile,
    MotorBasicProfile,
    RealestateBasicProfile,
} from '@finn-no/profilebox';
import {
    RealEstateExtendedProfile,
    RealEstateExtendedProfileProps,
} from '@finn-no/extended-profilebox';

export type AppProps = {
    adId: number;
    companyProfile: IBasicProfile;
    extendedProfile: RealEstateExtendedProfileProps | null;
    deviceType: string;
};

const App = ({
    adId,
    companyProfile,
    extendedProfile,
    deviceType,
}: AppProps): React.ReactElement => {
    if (extendedProfile) {
        return <RealEstateExtendedProfile {...extendedProfile} />;
    } else {
        switch (companyProfile.tag) {
            case 'RealEstate':
                return (
                    <RealestateBasicProfile
                        adId={adId}
                        deviceType={deviceType}
                        bpare={companyProfile}
                    />
                );
            case 'Motor':
                return <MotorBasicProfile adId={adId} bpam={companyProfile} />;
            default:
                return (
                    <FallbackProfile msg="Noe feilet dessverre i forsøket på å vise kontaktinformasjonen på denne annonsen" />
                );
        }
    }
};

export default App;
